import { dataProps, 
        itemListProps,
        paymentTermListProps } from './properties'

export const setExpenseBillList = (state, payload) => {
    state.list = payload.response
    state.nav.total = payload.total
state.nav.page_number = payload.page_number
if(!state.nav.had_results) {
   state.nav.had_results = payload.total>0
}
}    

export const setExpenseBillOutstandingList = (state, payload) => {
    state.outstanding_list = payload
}

export const resetExpenseBillOutstandingList = state => {
    state.outstanding_list = []
}

export const setExpenseBillData = (state, payload) => {
    state.props = payload.response
    
    if(state.props.item_list.length === 0) {
        state.props.item_list = [JSON.parse(JSON.stringify(itemListProps))]
    } else if(payload.copy) {
        state.props.item_list.forEach(element => {
            element.id = 0
        })
    }
    
    let key = 0
    state.props.item_list.forEach(element => {
        element.key = key
        key ++
    })

} 

export const setPurchaseOrderShippingAddress = (state, payload) => {
    state.props.shipment_address 
        = payload.legal_name+'\r\n'+payload.address+', \r\n'+payload.city_name+'-'+payload.postal_code+', '
                +payload.province_name+', '+payload.country_name+'.\r\n'
                +payload.contact_number+', '+payload.email_address+'.'
}

export const addNewExpenseBillItemListRow = state => {

    let key = 0
    state.props.item_list.push(JSON.parse(JSON.stringify(itemListProps)))

    state.props.item_list.forEach(element => {
        element.key = key
        key ++
    })

}

export const removeExpenseBillItemListRow = (state, payload) => {

    let key = 0

    state.props.item_list.splice(payload, 1)

    if(state.props.item_list.length === 0) {
        state.props.item_list = [JSON.parse(JSON.stringify(itemListProps))]
    }

    state.props.item_list.forEach(element => {
        element.key = key
        key ++
    })

}

export const addNewExpenseBillPaymentTermListRow = state => {

    let key = 0
    state.props.payment_term.push(JSON.parse(JSON.stringify(paymentTermListProps)))

    state.props.payment_term.forEach(element => {
        element.key = key
        key ++
    })

    setTimeout(() => {
        document.getElementById('payment_term_date_'+(key-1)).focus()
    }, 300);

}

export const removeExpenseBillPaymentTermListRow = (state, payload) => {

    let key = 0

    state.props.payment_term.splice(payload, 1)

    if(state.props.payment_term.length === 0) {
        state.props.payment_term = [JSON.parse(JSON.stringify(paymentTermListProps))]
    }

    state.props.payment_term.forEach(element => {
        element.key = key
        key ++
    })

}

export const resetExpenseBillData = state => {
    state.props = JSON.parse(JSON.stringify(dataProps))
}


// WEBPACK FOOTER //
// ./src/store/modules/expenseBill/mutations.js